import React from "react";
import "../animations/animate.css";
import AnimatedBody from "../animations/AnimatedBody";
import AnimatedTitle from "../animations/AnimatedTitle";

const About = () => {
  return (
    <section
      className="relative z-10 w-full items-center justify-center overflow-hidden bg-[#0E1016] bg-cover bg-center pt-16 pb-36 md:pt-20 md:pb-44 lg:pt-20 lg:pb-56"
      id="about"
    >
      <div className="mx-auto flex w-[90%] flex-col items-start justify-center lg:max-w-[1212.8px]">
        <AnimatedTitle
          text={"Frontier Insights on Web3 & AI"}
          className={
            "mb-10 text-left text-[40px] font-bold leading-[0.9em] tracking-tighter text-[#e4ded7] sm:text-[45px] md:mb-16 md:text-[60px] lg:text-[80px]"
          }
          wordSpace={"mr-[14px]"}
          charSpace={"mr-[0.001em]"}
        />

        <div className="mx-auto flex w-[100%] flex-col lg:max-w-[1200px] lg:flex-row lg:gap-20">
          <div className="mb-10 flex w-[100%] flex-col gap-4 text-[18px] font-medium  leading-relaxed tracking-wide text-[#e4ded7] md:mb-16 md:gap-6 md:text-[20px] md:leading-relaxed lg:mb-16  lg:max-w-[90%] lg:text-[24px] ">
            <AnimatedBody text="MintMind is dedicated to in-depth tracking of AI-driven projects in the Web3 space, focusing on the latest industry trends and technological innovations. We believe the convergence of AI and blockchain is reshaping the digital world and driving the next wave of transformation. By continuously monitoring cutting-edge projects, we aim to provide professionals and enthusiasts with timely, authoritative insights." />

            <AnimatedBody
              delay={0.1}
              text="Beyond news coverage, MintMind uncovers the stories behind the industry. We regularly interview founders, developers, and community members in the Web3 and AI sectors, sharing their experiences, perspectives, and ideas to help more people understand the ecosystem and spark new inspiration."
            />

            <AnimatedBody
              delay={0.2}
              text="Whether you are a developer, investor, or simply passionate about Web3 and AI, MintMind welcomes your participation. Join us as we witness and drive the integration of intelligence and decentralization, opening a new chapter in the digital future."
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
